module.exports = __webpack_public_path__ + "img/logoyellowbg.4d00d862.jpg";